const CardLogos = () => (
  <div className="flex flex-wrap mb-24">
    <img
      src={
        'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-4e0dcafc-91ca-44aa-b77a-8d780aefd31c-visa.png?auto=format'
      }
      alt="Visa"
      className="mx-8"
    />
    <img
      src={
        'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-b781bf5a-e4b1-4aff-8765-e804057652e9-mastercard.png?auto=format'
      }
      alt="Mastercard"
      className="mx-8"
    />
    <img
      src={
        'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-71b81a1b-f06c-4f45-8290-09709611367a-american-express.png?auto=format'
      }
      alt="Amex"
      className="mx-8"
    />
    <img
      src={
        'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-fa2fece0-a2bb-4d12-8c1a-e1d2d5d89983-dinners-club.png?auto=format'
      }
      alt="Dinners"
      className="mx-8"
    />
  </div>
);

export default CardLogos;
